<template>
  <a-spin :spinning="loading">
    <div class="role-content content-panel">
      <div class="search" style="margin-bottom:8px">
        <a-input-search v-model="searchRole" @search="initRoleList(0)" placeholder="请输入角色名称" />
      </div>
      <div class="addRole">
        <a-button type="primary" @click="addRole()" v-action:add block>新增角色</a-button>
      </div>

      <a-tree
        :treeData="roleList"
        :draggable="$auth('role.drag')"
        :expandedKeys="expandedKeys"
        @expand="onExpand"
        @dragstart="onStart"
        @drop="showConfirm"
        @select="select"
        :selectedKeys="selectedKeys"
      >
        <template slot="custom" slot-scope="role">
          <a-tooltip placement="topLeft" :title="role.remark">
            <span class="title-name" :ref="'role'+role.id" :title="role.name">{{ role.name }}</span>
          </a-tooltip>
          <div class="icon-panel">
            <a-tooltip>
              <template slot="title">编辑</template>
              <a-icon type="edit" v-action:update @click="editRole(role)" />
            </a-tooltip>
            <a-popconfirm
              style="left:100px!important"
              placement="topRight"
              title="您确定要删除此角色吗?"
              @confirm="e => remove(role)"
            >
              <a-tooltip>
                <template slot="title">删除</template>
                <a-icon type="delete" v-action:delete style="color: red"/>
              </a-tooltip>
            </a-popconfirm>
          </div>
        </template>
      </a-tree>

      <!-- 新增编辑角色弹窗 -->
      <role-edit ref="roleEdit" @updateList="updateList"></role-edit>
    </div>
  </a-spin>
</template>

<script>
import roleEdit from './modules/roleEdit.vue'
import { getRoleList, deleteRole, dragRole } from '@/api/roleList'
export default {
  components: {
    roleEdit
  },
  data () {
    return {
      // 角色搜索关键字
      searchRole: '',
      roleList: [],
      // 角色id
      roleId: 0,
      // 角色名称
      roleName: '',
      dragSort: Number,
      expandedKeys: [],
      selectedKeys: [],
      isAppend: false,
      firstLogin: true,
      loading: false
    }
  },
  methods: {
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
    },
    // 获取展开的节点
    getExpendkeys () {
      const expandedKeys = []
      const forKeys = arr => {
        for (const i in arr) {
          arr[i] = {
            ...arr[i],
            scopedSlots: {
              title: 'custom'
            }
          }
          const item = arr[i]
          if (item.children && item.children.length > 0) {
            if (expandedKeys.indexOf(item.key) === -1) {
              expandedKeys.push(item.key)
            }
            forKeys(item.children)
          }
        }
      }
      forKeys(this.roleList)
      this.expandedKeys = expandedKeys
    },
    // 获取侧边栏数据
    initRoleList (status) {
      // 调用接口
      this.loading = true
      const params = {
        name: this.searchRole.trim()
      }
      getRoleList(params).then(res => {
        // debugger
        if (res.status === 0) {
          if (res.data) {
            this.roleList = res.data
            // if (this.roleList && this.roleList.length > 0) {
            //   const refId = 'tree' + this.roleList[0].id
            //   this.$nextTick(() => {
            //     this.$refs[refId].click()
            //   })
            // }
            this.getExpendkeys()
          } else {
            this.roleList = []
          }
          this.getRoleManage(status)
          this.loading = false
        }
      })
    },
    // 获取初始右侧展示数据
    getRoleManage (status) {
      if (status === 0) {
        if (this.roleList.length > 0) {
          const selectedItem = this.roleList[0]
          this.selectedKeys.splice(0, 1)
          this.selectedKeys.push(selectedItem.key)
          // if (selectedItem.pid === 0) {
          //     selectedItem.pName = '一级角色'
          // }
          this.roleId = this.roleList[0].key ? this.roleList[0].key : ''
          this.roleName = this.roleList[0].name ? this.roleList[0].name : ''
          this.$store.commit('setRoleId', this.roleId)
          this.$store.commit('setRoleName', this.roleName)
        }
      }
      // 获取成功后调用获取右侧展示接口
      // this.$emit('refresh')
    },
    // 开始拖拽
    onStart (info) {
      this.dragSort = info.node.dataRef.sort
    },
    // 字典拖拽
    async onDrop (info, query) {
      // var query
      // console.log('拖拽的INFO', info)

      // const dropKey = info.node.eventKey // 目标id
      // const dragKey = info.dragNode.eventKey // 拖动项id
      // const dropPos = info.node.pos.split('-')
      // const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1])

      // // if (dropPosition === -1) {
      // //   sortPos = info.dropPosition + 2
      // // } else {
      // //   sortPos = info.dropPosition + 1
      // // }

      // // 判断是从上往下拖还是从下往上拖
      // // if (this.dragSort < info.node.dataRef.sort) {
      // //   realPos = info.dropPosition
      // // } else {
      // //   realPos = sortPos
      // // }

      // query = {
      //   id: dragKey,
      //   pid: dropPosition === 0 ? dropKey : info.node.dataRef.pid
      //   // position: realPos
      // }

      // console.log('query', query)

      // const res = await dragRole(query)

      // if (res.status === 0) {
      //   this.$message.success('操作成功!')
      //   // 拖拽完后重新获取树信息(因为sort值已经改变)
      //   this.initRoleList()
      // }
      const res = await dragRole(query)
      console.log('拖拽的返回', res)
      if (res.status === 0) {
        this.$message.success('操作成功!')
        // 拖拽完后重新获取树信息(因为sort值已经改变)
        this.initRoleList()
      } else {
        this.$message.error(res.info.message)
      }
    },
    // 拖拽的确认
    showConfirm (info) {
      // // const dropKey = info.node.eventKey // 目标id
      // const dropPos = info.node.pos.split('-')
      // const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1])

      // const dragName = info.dragNode.dataRef.name
      // const nodeName = dropPosition === 0 ? info.node.dataRef.name : info.node.dataRef.pName === '' ? '一级角色' : info.node.dataRef.pName
      // this.$confirm({
      //   title: '父节点修改确认',
      //   content: `您确定修改【${dragName}】的父节点为【${nodeName}】吗？`,
      //   onOk: e => this.onDrop(info, e),
      //   onCancel () {}
      // })
      const vm = this
      var realPos, query
      console.log('拖拽的INFO', info)
      // const dropKey = info.node.eventKey
      // const dragKey = info.dragNode.eventKey
      const dropPos = info.node.pos.split('-')
      const dragPos = info.dragNode.pos.split('-')
      const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1])
      // console.log('dropPosition', dropPosition)
      // const parentNode = info.dragNode.pos.split('-')[1]
      // console.log('dropPos', dropPos)
      // console.log('dragPos', dragPos)
      // console.log('parentNode', info.dragNode.pos.split('-')[1])
      // 判断是否在同一个父节点下移动
      if (dragPos.length === dropPos.length && dragPos[dragPos.length - 2] === dropPos[dropPos.length - 2]) {
        if (dropPosition === -1) {
          realPos = Number(dropPos[dropPos.length - 1]) + 1
        } else {
          realPos = Number(dropPos[dropPos.length - 1]) + 2
        }
        if (Number(dragPos[dragPos.length - 1]) < Number(dropPos[dropPos.length - 1])) {
          realPos = realPos - 1
        }
      } else {
        if (dropPosition === -1) {
          realPos = info.dropPosition + 2
        } else {
          realPos = info.dropPosition + 1
        }
      }
      // 阻止角色拖拽到下级
      if (dropPosition === 0) {
        return
      }
      query = {
        id: info.dragNode.dataRef.id,
        pid: dropPosition === 0 ? info.node.dataRef.id : info.node.dataRef.pid,
        position: realPos
      }
      // console.log('query', query)
      // console.log('dropPosition', dropPosition)
      let showTitle = ''
      if (dropPosition === 0) {
        console.log('长度', info.node.dataRef.children.length)
        const dropId = info.node.eventKey
        const dragPId = info.dragNode.dataRef.pid
        if (dragPId === dropId) {
          query.position = info.node.dataRef.children.length
        } else {
          query.position = info.node.dataRef.children.length + 1
        }
        // const childPos = info.node.dataRef.children.length + 1
        // query.position = childPos
        showTitle = `您确定修改【${info.dragNode.dataRef.name}】的父节点为【${info.node.dataRef.name}】并调整顺序为第【${query.position}】位吗?`
      } else {
        // showTitle = `您确定修改【${info.dragNode.dataRef.name}】${info.node.dataRef.pName ? '的父节点' : ''}为【${info.node.dataRef.pName ||
        //   '一级角色'}】并调整顺序为第【${query.position}】位吗?`

        showTitle = `您确定调整【${info.dragNode.dataRef.name}】的顺序为第【${query.position}】位吗?`
      }
      this.$confirm({
        title: showTitle,
        onOk: () => this.onDrop(info, query),
        onCancel () {}
      })
    },
    // 选择一个字典
    select (selectedKeys, info) {
      if (selectedKeys.length === 0) {
        selectedKeys.push(info.node.eventKey)
      }
      this.selectedKeys = selectedKeys
      this.$store.commit('setRoleId', info.node.$vnode.data.key)
      this.$store.commit('setRoleName', info.node.$vnode.data.props.name)
      this.isAppend = false
    },
    // 新增角色
    addRole (role) {
      this.$refs.roleEdit.setType(this.$sysInfo.MODAL_ADD)
      this.$refs.roleEdit.setTitle('新增角色')
      const model = {
        pid: role ? role.key : 0,
        pName: role ? role.name : '一级角色'
      }
      this.$refs.roleEdit.setModel(model)
      this.$refs.roleEdit.open(true)
    },
    // 修改角色
    editRole (role) {
      if (role.pid === 0) {
        role.pName = '一级角色'
      }
      this.$refs.roleEdit.setType(this.$sysInfo.MODAL_MODIFY)
      this.$refs.roleEdit.setTitle('编辑角色')
      this.$refs.roleEdit.setModel(role)
      this.$refs.roleEdit.open(true)
    },
    // 删除角色
    remove (role) {
      deleteRole(role.id)
        .then(res => {
          if (res.status === 0) {
            this.$message.success(res.info.message)
            this.$store.commit('setRoleId', 0)
            this.$store.commit('setRoleName', '')
            this.initRoleList(0)
          } else {
            this.$message.error(res.info.message)
          }
        })
        .catch(() => {
          this.$message.error('error!')
        })
    },
    // 刷新侧边栏数据
    updateList () {
      this.initRoleList()
    }
  },
  mounted () {
    // 获取侧边栏数据
    this.initRoleList(0)
    // this.getRoleManage();
  }
}
</script>

<style lang="less">
.ant-tooltip {
  z-index: 1020;
}
.role-content {
  // .ant-tree-node-content-wrapper {
  //   display: inline-block;
  //   width: calc(100% - 25px);

  //   .ant-tree-title {
  //     display: inline-block;
  //     width: 100%;

  //     .title-name {
  //       // width: inherit;
  //       width:calc(100% - 57px);
  //       display: inline-block;
  //       // white-space: pre-line;
  //       overflow:hidden;
  //       text-overflow:ellipsis;
  //     }
  //   }
  // }
  // .title {
  //   float: left;
  // }

  // .ant-tree {
  //   line-height: 3;

  //   .ant-tree-node-content-wrapper,
  //   .ant-tree-switcher {
  //     margin-top: 7px;
  //   }
  //   .ant-tree-node-content-wrapper:hover {
  //     background: transparent;
  //   }
  //   .ant-tree-treenode-selected {
  //     background: #e6f7ff;
  //     .ant-tree-node-selected {
  //       background: transparent;
  //     }
  //   }

  //   .ant-tree-child-tree {
  //     background: #fff;
  //   }
  //   li {
  //     position: relative;
  //     line-height: 3;
  //     padding-bottom: 0;

  //     ul {
  //       padding: 0px 0 0 10px;
  //     }
  //   }
  // }
  .ant-btn {
    margin-bottom: 12px;
  }

  // .icon-panel {
  //   float: right;
  //   position: absolute;
  //   right: 10px;
  //   top: 13px;

  //   .anticon-plus,
  //   .anticon-edit,
  //   .anticon-delete {
  //     margin-left: 5px;
  //     color: #1890ff;
  //   }
  // }
}
</style>
